<template>
    <div class="c-dashboard-monthly"
        :data-component-name="$options.name"
    >
        <!-- <pre>
{{monthdays}}
        </pre> -->
        <div class="c-dashboard__loading" v-if="$apollo.queries.projects.loading || !showProjects">
            <q-spinner
                color="primary"
                size="1em"
            />
            Chargement en cours...
        </div>
        <div class="c-monthly-row -bg">
            <div class="c-monthly-cell -gap"></div>
            <div class="c-monthly-cell"
                :key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
            </div>
            <div class="c-monthly-cell -gap"></div>
        </div>

        <!-- FOOTER -->
        <MonthViewFooter
            :currentDate="currentDate"
            :monthrange="monthrange"
            :monthdays="monthdays"
            @set-current-date="$emit('set-current-date', $event)"
            @set-date-offset="dateOffset = $event"
            @set-more-filters="moreFilters=$event"
        />
        <!-- <FloatingControls
            @new-project="newProject=true"
        /> -->
        <FloatingControls
            @new-project="createNewProject()"
        />

        <div class="c-monthly-row__wrap" v-show="showProjects==true">

            <div v-if="newProject"
                :id="'project'+newProjectObj.id"
            >
                <div class="c-monthly-row">
                    <div class="c-monthly-cell -gap">
                    </div>
                    <div class="c-monthly-cell -name">
                        <div class="c-project__category"></div>
                        <div class="c-project__name">
                            <div class="u-text-truncate">
                                <q-icon class="q-mr-sm" :class="newProjectModel.status.toLowerCase()" name="new_releases" v-if="newProjectModel.status=='NEWPROJECT'"></q-icon>
                                <!-- <span :class="'o-status-pin -'+ newProjectObj.status.toLowerCase()">STATUS CLASS .-draft,.-published,.-alert,.-confirmed,.-completed -->
                                <!-- </span> -->
                                {{ newProjectObj.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c-dashboard-project">
                    <ProjectForm class="c-dashboard-project__inner"
                        :newProject="true"
                        @refetch-projects="newProjectCreated($event)"
                        @cancel="toggleProjectDetails(newProjectObj.id)"
                        :project="newProjectObj"
                        :weekrange="daterange"
                        :projectDetailsVisible="parseInt(projectDetailsVisible)"
                    />
                </div>

            </div>

            <div class="c-monthly-row">
                <div class="c-monthly-cell -gap" style="height: 30px;"><!-- NEEDED FOR 20PX GAP --></div>
                <div class="c-monthly-cell -name -order-by" style="height: 30px;">
                    <div class="c-project__name u-text-truncate">
                        <OrderBy
                            :options="[
                                { value: 'name', label: 'Nom du projet' },
                                { value: 'updated_at', label: 'Date de mise à jour' },
                                { value: 'created_at', label: 'Date de création' }
                            ]"
                            @update:orderBy="orderBy=$event.field;
                                orderSort=$event.sort;"
                            scope="monthView"
                        />
                    </div>
                </div>
            </div>
            <template v-show="showProjects==true">
                <div
                    :key="project.id"
                    v-for="project in projectList"
                    :id="'project'+project.id"
                >
                    <div
                        class="c-monthly-row"
                        v-if="project.assignmentsSummary.datedAssignments.length>0 || projectsFilter=='All' || projectsFilter=='Archived' || projectsFilter=='MyProjects' || projectsFilter=='ToPlan'"
                    >
                        <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                        <div class="c-monthly-cell"
                            :key="index"
                            v-for="(monthday, index) in monthdays"
                            :class="[
                                {
                                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6,
                                },
                                'week-'+project.id+'-'+monthday.week,
                                'weekr-'+project.id+'-'+monthday.weekRange.str.from+'-'+monthday.weekRange.str.to
                            ]"
                            @mouseenter="addClass('.week-'+project.id+'-'+monthday.week)"
                            @mouseleave="removeClass('.week-'+project.id+'-'+monthday.week)"
                        >
                            <div class="c-project" v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr]"
                                :class="project.assignmentsSummary.datedSummaries[monthday.dateStr].state"
                                @click="showWeekShifts(project.id, monthday.dateStr); selectedShift='.weekr-'+project.id+'-'+monthday.weekRange.str.from+'-'+monthday.weekRange.str.to"
                            >
                            <!-- <div class="c-project" v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr]"
                                :class="project.assignmentsSummary.datedSummaries[monthday.dateStr].state"
                                @click="$emit('jump-to-project-week', {currentDate: monthday.dateStr, projectID: project.id} )"
                            > -->
                                <div v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr].state=='-draft'">
                                    {{ project.assignmentsSummary.datedSummaries[monthday.dateStr].draftCount }}
                                </div>

                                <div v-else>
                                    {{ project.assignmentsSummary.datedSummaries[monthday.dateStr].count }}

                                    <div class="-progression__wrap"
                                        v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr].state!='-completed' && (project.assignmentsSummary.datedSummaries[monthday.dateStr].progression!='0%' || project.assignmentsSummary.datedSummaries[monthday.dateStr].deniedProgression!='0%')" 
                                    >
                                        <div class="-progression" v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr].state!='-completed'" :style="'width:'+project.assignmentsSummary.datedSummaries[monthday.dateStr].progression">
                                        </div>
                                        <div class="-progression -denied" v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr].state!='-completed'" :style="'width:'+project.assignmentsSummary.datedSummaries[monthday.dateStr].deniedProgression">
                                        </div>
                                    </div>
                                </div>
                                <q-tooltip v-if="project.assignmentsSummary.datedSummaries[monthday.dateStr].tooltipStr">
                                    <div v-html="project.assignmentsSummary.datedSummaries[monthday.dateStr].tooltipStr"></div>
                                </q-tooltip>
                            </div>
                        </div>

                        <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

                        <div class="c-monthly-cell -name" @click="toggleProjectDetails(project.id)">
                            <div class="c-project__category" :style="'border-color:'+project.projectCategories[0].color" v-if="project.projectCategories.length"></div>
                            <div class="c-project__category" v-else style="border-right:none;"></div>
                            <div class="c-project__name u-text-truncate" :title="project.name"
                                :class="{'is-archived': project.status=='ARCHIVED'}"
                            >
                                <div class="u-text-truncate">
                                    <q-icon class="q-mr-sm" name="archive" v-if="project.status=='ARCHIVED'">
                                        <q-tooltip>
                                            {{ project.statusStr }}
                                        </q-tooltip>
                                    </q-icon>
                                    <q-icon class="q-mr-sm" :class="project.status.toLowerCase()" name="new_releases" v-else-if="project.status=='NEWPROJECT'">
                                        <q-tooltip>
                                            {{ project.statusStr }}
                                        </q-tooltip>
                                    </q-icon>
                                    <q-icon class="q-mr-sm" :class="project.status.toLowerCase()" name="people" v-else-if="project.status=='TOPLAN'">
                                        <q-tooltip>
                                            {{ project.statusStr }}
                                        </q-tooltip>
                                    </q-icon>
                                    <span class="o-status-pin" :class="project.state" v-else><!-- STATUS CLASS .-draft,.-published,.-alert,.-confirmed,.-completed -->
                                        <q-tooltip>
                                            {{ project.statusStr }}
                                        </q-tooltip>
                                    </span>
                                    {{ project.name }}
                                </div>
                                <ProjectCardToggle class="q-mr-xs" :projectID="project.id" :size="'16px'" />
                            </div>
                        </div>
                    </div>

                    <div class="c-dashboard-project" v-if="showProjectDetails==project.id">
                        <ProjectForm class="c-dashboard-project__inner"
                            @refetch-projects="refreshProject($event)"
                            @refresh-project="refreshProjectSummary($event)"
                            @deleted-projects="refetchProjects($event)"
                            @cancel="toggleProjectDetails(project.id)"
                            :project="project"
                            :weekrange="daterange"
                            :projectDetailsVisible="parseInt(projectDetailsVisible)"
                            :shiftOverride="shiftOverride"
                        />
                    </div>
                    
                    <div class="c-dashboard" v-if="showProjectsShifts && showProjectsShifts==project.id" style="margin-top:0; padding-bottom:0;">
                        <div v-if="projectShifts.loading" class="c-dashboard__item -shifts-loading">
                            <div>
                                <q-spinner
                                    color="primary"
                                    size="1em"
                                />
                                Chargement en cours...
                            </div>
                        </div>
                        <Shifts
                            v-else
                            :showHeaders="true"
                            :currentDate="currentDate"
                            :shifts="projectShifts.project.shifts"
                            :shiftsView="shiftsView"
                            :weekrange="weekrange"
                            :draftShifts="projectShifts.project.draftShifts"
                            :prevShift="projectShifts.project.prevShift"
                            :nextShift="projectShifts.project.nextShift"
                            @set-current-date="showWeekShifts(project.id, $event)"
                            @refresh-project="refreshProjectSummary($event)"
                            @create-shift-override="toggleProjectDetails(project.id, false); shiftOverride=$event; $emit('create-shift-override', $event)"
                        />
                    </div>
                </div>
                <div
                    class="c-monthly-row"
                    v-if="projects && projects.paginatorInfo.hasMorePages && !$apollo.queries.projects.loading"
                    ref="loadMoreProjects"
                >
                    <div style="color: white">Plus de résultats...</div>
                </div>
            </template>
        </div>
        <div class="c-monthly-row__wrap -is-filling-space">
            <div class="-spacer"></div>
        </div>
        <div class="c-monthly-row -header">
            <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>

            <div class="c-monthly-cell"
                :key="index"
                v-for="(monthday, index) in monthdays"
                :class="{
                    '-weekday' : monthday.date.getDay()!=0 && monthday.date.getDay()!=6,
                    '-weekend' : monthday.date.getDay()==0 || monthday.date.getDay()==6
                }"
            >
                <AssignmentsCardToggle v-if="monthday.summary" :summary="monthday.summary">
                    <div>
                        {{ monthday.summary.count }}
                    </div>
                    <div v-if="monthday.summary.draftCount != monthday.summary.count">
                        {{ monthday.summary.draftCount }}
                    </div>
                </AssignmentsCardToggle>
            </div>
            <div class="c-monthly-cell -gap"><!-- NEEDED FOR 20PX GAP --></div>
        </div>
        <q-dialog v-model="projectNotFound"
            @show="focusDefault()"
        >
            <q-card>
                <q-card-section class="row items-center no-wrap">
                    <q-avatar icon="warning" color="primary" text-color="white" />
                    <span class="q-ml-sm">Le projet demandé n'a pas été chargé, mais des résultats supplémentaires sont disponibles.</span>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn flat label="Cancel" color="primary" v-close-popup
                        @click="$eventBus.$emit('jump-to-project', null)"
                    />
                    <q-btn flat label="Charger plus de résultats" color="primary" v-close-popup class="js-more-projects-btn"
                        @click="getMoreProjects()"
                    />
                </q-card-actions>
            </q-card>
        </q-dialog>

    </div>
</template>

<script>
    import ProjectForm from '@/components/forms/ProjectForm'
    import MonthViewFooter from "@/components/nav/MonthViewFooter";
    import {getDatesBetween, getMonthLimits, dayOfWeekStr, monthStr, dayStr, getWeeksLimits} from "@/js/dateUtilities"
    import { PROJECTSSUMMARY, PROJECT } from '@/graphql/project/queries'
    import moment from 'moment';
    import Shifts from '@/components/projects/Shifts'
    import FloatingControls from '@/components/nav/FloatingControls'
    // import MoreFilters from '@/components/nav/MoreFilters'
    import {statusStr} from '@/js/utilities';
    import { MYPROFILE } from '@/graphql/user/queries'
    import uniqBy from 'lodash/uniqBy'
    // import { v4 as uuidv4 } from 'uuid';


    export default {
        name: 'MonthView',
        components: {
            MonthViewFooter,
            ProjectForm,
            Shifts,
            FloatingControls,
            // MoreFilters,
        },
        props: {
            // projectIDs: {
            //     type: [Number, Array],
            //     default(){
            //         return new Array()
            //     }
            // },
            currentDate: String,
            projectsFilter: {
                type: String,
                default: 'All'
            },
            shiftsView: {
                type: String,
                default: 'profession'
            },
            scrollToProject: {
                type: String,
                default: null
            }
            // newProject: {
            //     type: Boolean,
            //     default: false
            // },
        },
        data() {
            return {
                projectIDs: [],
                showProjects: false,
                showProjectsShifts: false,
                showProjectDetails: 0,
                projectDetailsVisible: 0,
                totalCount: {},
                monthdays: [],
                weekrange: {},
                projectShifts: {loading:true, project:null},
                lastDateRange: null,
                newProject: false,
                newProjectObj: {},
                newProjectModel: {
                    id: 0,
                    name: "Nouveau projet",
                    status: "NEWPROJECT",
                    projectStatus: "NEWPROJECT",
                    shifts: [],
                    draftShifts: [],
                    customers: [],
                    customtags: [],
                    projectShifts: [],
                },
                shiftOverride: null,
                selectedShift: null,
                myProfileID: null,
                pageSize: 20,
                currentPage: 1,
                bodyScrollTo: null,
                projectScrollToTo: null,
                loading: true,
                earlyFetchedProjects: {},
                projectNotFound: false,
                notFetched: false,
                moreFilters: null,
                dateOffset: 0,
                orderBy: 'name',
                orderSort: 'ASC',
                // myProfileID: null
            }
        },
        mounted() {
            this.monthdays=this.setMonthDays();
            this.lastDateRange=this.daterange.str.from+this.daterange.str.top
            this.$eventBus.$emit('clear-more-filters');

            let passiveSupported = false;
            try {
                const options = {
                    get passive() { 
                        passiveSupported = true;
                        return false;
                    }
                };

                window.addEventListener("test", null, options);
                window.removeEventListener("test", null, options);
            } catch(err) {
                passiveSupported = false;
            }
            document.addEventListener('scroll', this.onScroll, passiveSupported ? { passive: true } : false);


            this.$eventBus.$on('jump-to-loaded-project', function(e){
                if(this.notFetched){
                    this.notFetched=false;
                    return
                }
                clearTimeout(this.projectScrollToTo);
                this.projectScrollToTo=setTimeout(function(){
                    this.scrollToFunc(e.projectID);
                }.bind(this))
            }.bind(this))
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
            this.$eventBus.$off('jump-to-loaded-project');
        },
        computed: {
            queryFilters(){
                if(!this.projectsFilter) return null;
                
                if(this.projectsFilter=='Archived') return {
                    allProjects: false,
                    archivedProjects: true,
                }
                if(this.projectsFilter=='Drafts') return {
                    draftProjects: true,
                }
                if(this.projectsFilter=='Confirmed') return {
                    confirmedProjects: true,
                }
                if(this.projectsFilter=='Actives') return {
                    activeProjects: true,
                }
                if(this.projectsFilter=='MyProjects' && this.myProfileID) return {
                    projectManager: this.myProfileID,
                    // activeProjects: true,
                }
                if(this.projectsFilter=='ToPlan') return {
                    status: "TOPLAN",
                    // activeProjects: true,
                }

                return null
            },
            projectList(){
                if(!this.projects || !this.projects.data) return [];
                let projectList=JSON.parse(JSON.stringify(this.earlyFetchedProjects.data));
                let summaries={};

                projectList.forEach(function(project){
                    project.state="-completed";
                    project.statusStr=statusStr(project.status);
                    if(project.status=="DRAFT") project.state="-draft";//.-draft,.-published,.-alert,.-confirmed,.-completed
                    if(project.status=="HASDRAFT") project.state="-hasdraft";//.-draft,.-published,.-alert,.-confirmed,.-completed
                    if(project.status=="PUBLISHED") project.state="-published";//.-draft,.-published,.-alert,.-confirmed,.-completed
                    project.assignmentsSummary.datedSummaries={}
                    // console.log(project.assignmentsSummary.datedAssignments);
                    project.assignmentsSummary.datedAssignments.forEach(function(datedAssignment){
                        let date=datedAssignment.date
                        project.assignmentsSummary.datedSummaries[date]={};
                        project.assignmentsSummary.datedSummaries[date]=this.getSummaryState(datedAssignment, project)

                        if(!summaries[date]){
                            summaries[date]=Object.assign({}, project.assignmentsSummary.datedSummaries[date]);
                        }else{
                            summaries[date].count=summaries[date].count+project.assignmentsSummary.datedSummaries[date].count;
                            summaries[date].accepted=summaries[date].accepted+project.assignmentsSummary.datedSummaries[date].accepted;
                            summaries[date].denied=summaries[date].denied+project.assignmentsSummary.datedSummaries[date].denied;
                            summaries[date].pending=summaries[date].pending+project.assignmentsSummary.datedSummaries[date].pending;
                            summaries[date].draftCount=summaries[date].draftCount+project.assignmentsSummary.datedSummaries[date].draftCount;
                            summaries[date].unassigned=summaries[date].unassigned+project.assignmentsSummary.datedSummaries[date].unassigned;
                            summaries[date].assignmentErrorCount=summaries[date].assignmentErrorCount+project.assignmentsSummary.datedSummaries[date].assignmentErrorCount;
                            summaries[date].absenceErrorCount=summaries[date].absenceErrorCount+project.assignmentsSummary.datedSummaries[date].absenceErrorCount;
                            summaries[date].maybe=summaries[date].maybe+project.assignmentsSummary.datedSummaries[date].maybe;
                        }

                        // if(summaries[date].assignmentErrorCount>0 || summaries[date].denied>0 || summaries[date].unassigned>0) project.state="-alert"
                    }.bind(this))
                }.bind(this))
                this.monthdays.forEach(function(monthday, key){
                    if(summaries[monthday.dateStr]){
                        this.monthdays[key].summary=this.getSummaryState(summaries[monthday.dateStr]);
                    }
                }.bind(this))
                return projectList;
            },
            monthrange(){
                return getMonthLimits(this.currentDate)
            },
            daterange(){
                return getMonthLimits(this.currentDate, 36 + this.dateOffset, -6 + this.dateOffset)
            },
            monthWeeks(){
                let monthWeeks=[];
                let starting=true;
                let i=-1;
                this.monthdays.forEach(function(monthday){
                    if(monthday.date.getDay()==0 || starting){
                        i++;
                        monthWeeks[i]=[];
                    }
                    monthWeeks[i].push(monthday);
                    starting=false;
                })

                return monthWeeks;
            }
        },
        methods: {
            log(msg){
                console.log(msg)
            },

            focusDefault(){
                // setTimeout(function(){
                this.$nextTick(function () {
                    if(document.querySelector(".js-more-projects-btn")) document.querySelector(".js-more-projects-btn").focus();
                })
                // }, 100)
            },

            scrollToFunc(projectID=null){
                let toID=this.scrollToProject
                if(projectID) toID=projectID;
                if(toID && document.getElementById("project"+toID) && !this.loading){
                    this.toggleProjectDetails(toID, false)
                    this.$eventBus.$emit('jump-to-project', null);
                    return true;
                }else if(!this.loading && !document.getElementById("project"+toID)){
                    if(this.projects.paginatorInfo.hasMorePages){
                        this.projectNotFound=true;
                    }
                    return false;
                }
                return false;
                // if(this.scrollToProject && document.getElementById("project"+this.scrollToProject)) this.$scrollTo('#'+this.scrollToProject, 200, {offset:-60})
            },
            createNewProject(){
                if(this.newProject) return;

                this.newProjectObj = JSON.parse(JSON.stringify(this.newProjectModel))
                this.newProjectObj.id = -1;
                this.showProjectDetails=this.newProjectObj.id;
                this.projectDetailsVisible=this.newProjectObj.id;
                this.newProject=true;
                setTimeout(function(){
                    let offset=-120;
                    let moreFiltersEL=document.querySelector(".js-more-filters-nav");
                    if(moreFiltersEL) offset=offset-moreFiltersEL.offsetHeight;

                    this.$scrollTo(
                        "#project-1",
                        0,
                        {
                            offset: offset,
                        }
                    )
                }.bind(this), 250)                
            },
            showWeekShifts(projectID, date, refresh=false){
                let to=0;
                if(this.projectDetailsVisible!=0 && this.projectDetailsVisible!=projectID){
                    to=250;
                    this.toggleProjectDetails(this.projectDetailsVisible);
                }
                this.$emit('set-current-date', date);
                setTimeout(function(){
                    if(!refresh && this.showProjectsShifts==projectID && this.weekrange.str.from==getWeeksLimits(date, this.$generalSettings.settings.firstDayOfWeek).str.from){
                        this.showProjectsShifts=0;
                        this.selectedShift=null;
                        return;
                    }
                    this.weekrange=getWeeksLimits(date, this.$generalSettings.settings.firstDayOfWeek);
                    this.showProjectsShifts=projectID
                    this.projectShifts.loading=true;
                    this.fetchProjectShifts(projectID, this.weekrange)
                }.bind(this), to)
            },
            fetchProjectShifts(projectID, date){
                this.$apollo.addSmartQuery('project', {
                    query: PROJECT,
                    fetchPolicy: 'cache-and-network',
                    manual: true,
                    variables() {
                        return {
                            id: projectID,
                            shiftsDateRange: date.str
                        }
                    },
                    result ({ data/*, loading, networkStatus*/ }) {
                        if(data){
                            if(this.projectDetailsVisible!=0 && this.projectDetailsVisible != data.project.id) return null;
                            this.projectShifts.project=data.project
                            this.showProjectsShifts=data.project.id;
                            this.projectShifts.loading=false
                            if(this.selectedShift){
                                this.selectedShift='.weekr-'+data.project.id+'-'+date.str.from+'-'+date.str.to
                                document.querySelectorAll(".-is-selected").forEach(function(item){
                                    item.classList.remove('-is-selected')
                                })
                                document.querySelectorAll(this.selectedShift).forEach(function(item){
                                    item.classList.add('-is-selected')
                                })
                            }
                        }
                    },
                })
            },
            newProjectCreated(createdtedProject){
                // this.projectDetailsVisible='zzz';
                this.newProject=false
                this.notFetched=true
                this.$eventBus.$emit('jump-to-project', { projectID: createdtedProject.id, currentDate: createdtedProject.start_date})
                this.refetchProjects();
            },
            refreshProject(updatedProject){
                this.projects.data.forEach(function(project, key){
                    if( project.id==updatedProject.id){
                        this.projects.data[key]=updatedProject
                    }
                }.bind(this))
                if(this.showProjectsShifts==updatedProject.id) this.showWeekShifts(updatedProject.id, this.currentDate, true)
            },
            refetchProjects(){
                if(this.$apollo.queries.projects) this.$apollo.queries.projects.refetch();
            },
            toggleProjectDetails(visible, toggle=true){
                if(this.showProjectsShifts!=visible) this.showProjectsShifts=0;
                this.projectDetailsVisible=visible

                let offset=-120;
                let moreFiltersEL=document.querySelector(".js-more-filters-nav");
                if(moreFiltersEL) offset=offset-moreFiltersEL.offsetHeight;

                clearTimeout(this.visibilityTO);
                if(visible==this.showProjectDetails){
                    if(!toggle){
                        let to=350;
                        setTimeout(function(){
                            this.$scrollTo(
                                "#project"+visible,
                                200,
                                {
                                    offset: offset,
                                    onDone: function(){
                                        this.showProjectDetails=visible;
                                        this.$scrollTo("#project"+visible, 200, {offset: offset}) //fix timing bad offset
                                    }.bind(this)
                                }
                            )
                        }.bind(this), to);
                        return;
                    } 
                    this.projectDetailsVisible=0
                    this.visibilityTO=setTimeout(function(){
                        this.showProjectDetails=0;
                        // if(newProject) this.newProjectCreated(newProject);
                        this.newProject=false;
                    }.bind(this), 200)
                }else{
                    let to=350;
                    if(this.showProjectDetails==0) to=0;
                    setTimeout(function(){
                        this.$scrollTo(
                            "#project"+visible,
                            200,
                            {
                                offset: offset,
                                onDone: function(){
                                    this.showProjectDetails=visible;
                                    this.$scrollTo("#project"+visible, 200, {offset: offset}) //fix timing bad offset
                                }.bind(this)
                            }
                        )
                    }.bind(this), to);
                }
            },
            addClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.add('hover')
                })
            },
            removeClass(selector){
                document.querySelectorAll(selector).forEach(function(item){
                    item.classList.remove('hover')
                })
            },
            getSummaryState(summary, project=null){
                let state='', tooltips=[]/*, isAlert=false*/;
                summary.tooltipStr='';
                if(summary.pending > 0){
                    if(summary.pending==1) tooltips.push("Cette journée contient une affectation en attente d'acceptation de l'employé")
                    if(summary.pending>1) tooltips.push("Cette journée contient "+ summary.pending + " affectations en attente d'acceptation de l'employé")
                    state='-published'
                }
                if(summary.maybe > 0){
                    if(summary.maybe==1) tooltips.push("Cette journée contient une affectation répondue peut-être par l'employée")
                    if(summary.maybe>1) tooltips.push("Cette journée contient "+ summary.maybe +" répondues peut-être par l'employée")
                    // if(state!='-alert'){
                        state='-published'
                        if(project) {
                            project.state="-published";
                            project.statusStr="Erreur : Ce projet contient une ou plusieurs affectations répondue peut-être par l'employée"
                        }
                    // }
                    // isAlert=true;
                }
                if(summary.denied > 0){
                    if(summary.denied==1) tooltips.push("Cette journée contient une affectation refusée par l'employée")
                    if(summary.denied>1) tooltips.push("Cette journée contient "+ summary.denied +" affectations refusées par l'employée")
                    state='-alert'
                    if(summary.pending > 0 || summary.maybe > 0) state='-published'
                    if(project) {
                        project.state="-alert";
                        project.statusStr="Ce projet contient une ou plusieurs affectations refusée par l'employée"
                    }
                    // isAlert=true;
                }
                if(summary.unassigned > 0){
                    if(summary.unassigned==1) tooltips.push("Cette journée contient une affectation non assignée")
                    if(summary.unassigned>1) tooltips.push("Cette journée contient "+ summary.unassigned +" affectations non assignées")
                    state='-alert'
                    if(project) {
                        project.state="-alert";
                        project.statusStr="Ce projet contient une ou plusieurs affectations non assignées"
                    }
                    // isAlert=true;
                }
                if(summary.assignmentErrorCount > 0){
                    if(summary.assignmentErrorCount==1) tooltips.push("Cette journée contient une affectation avec conflit d'horaire")
                    if(summary.assignmentErrorCount>1) tooltips.push("Cette journée contient "+ summary.assignmentErrorCount +" affectations avec conflits d'horaire")
                    state='-alert'
                    if(project) {
                        project.state="-alert";
                        project.statusStr="Ce projet contient une ou plusieurs affectations avec conflit d'horaire"
                    }
                    // isAlert=true;
                }
                if(summary.absenceErrorCount > 0){
                    if(summary.absenceErrorCount==1) tooltips.push("Cette journée contient une affectation avec absence")
                    if(summary.absenceErrorCount>1) tooltips.push("Cette journée contient "+ summary.absenceErrorCount +" affectations avec absences")
                    state='-alert'
                    if(project) {
                        project.state="-alert";
                        project.statusStr="Ce projet contient une ou plusieurs affectations avec conflit d'horaire"
                    }
                    // isAlert=true;
                }

                if(summary.count>0 && summary.count==summary.accepted && summary.assignmentErrorCount==0 && summary.absenceErrorCount==0) state='-completed'

                if(summary.hasDraftShift){
                    tooltips.push("Cette journée contient des informations non publiées (brouillons)")
                    state=state+' -hasdraft'
                }
                if(summary.count == 0 && summary.draftCount>0){
                    tooltips.push("Les affectations n'ont pas été publiées pour cette journée")
                    state='-draft'
                    summary.hasDraftShift=true;
                }
                if(summary.accepted==0){
                    summary.progression="0%";
                }else{
                    summary.progression=(summary.accepted*100/summary.count)+"%";
                }
                if(summary.denied==0){
                    summary.deniedProgression="0%";
                }else{
                    summary.deniedProgression=(summary.denied*100/summary.count)+"%";
                }
                summary.state=state
                if(tooltips.length>0){
                    summary.tooltipStr='• '+tooltips.join('<br>• ');
                }
                return summary;
            },
            setMonthDays(){
                let monthdays=[]
                let dateRange=getDatesBetween(this.daterange.obj.from, this.daterange.obj.to)
                let starting=true;
                let week=-1;
                let weekRange=null;
                dateRange.forEach(function(date){
                    if(!weekRange) weekRange=getWeeksLimits(date, this.$generalSettings.settings.firstDayOfWeek);
                    if(date.getDay()==this.$generalSettings.settings.firstDayOfWeek || starting){
                        week++;
                        starting=false;
                        weekRange=getWeeksLimits(date, this.$generalSettings.settings.firstDayOfWeek);
                    }
                    monthdays.push({
                        totalOccupation: 0,
                        date: date,
                        dateStr: moment(date).format('YYYY-MM-DD'),
                        day: dayStr(date.getDate()),
                        week: week,
                        weekRange: weekRange,
                        dayOfWeekStr: dayOfWeekStr(date),
                        monthStr: monthStr(date),
                        summary: {
                            count: 0,
                            draftCount: 0,
                            unassigned: 0,
                            state: ''
                        }
                    })
                }.bind(this))

                return monthdays;
            },
            refreshProjectSummary(projectID){
                if(!projectID) return;

                let variables={};
                if(this.daterange) variables.dateRange=this.daterange.str
                if(this.daterange) variables.shiftsDateRange=this.daterange.str
                variables.ids=[projectID]

                this.$apollo.query({
                    query: PROJECTSSUMMARY,
                    fetchPolicy: 'network-only',
                    variables: {
                        ...variables
                    },
                }).then(() => {
                })
            },
            onScroll(){
                // clearTimeout(this.bodyScrollTo);
                // this.bodyScrollTo = setTimeout(function(){
                    var loadMoreEl = this.$refs["loadMoreProjects"];
                    // var loadMoreParent = document.body;
                    if (loadMoreEl) {
                        var marginTop = loadMoreEl.getBoundingClientRect().top;
                        var innerHeight = (window.innerHeight || document.documentElement.clientHeight)
                        if ((marginTop < innerHeight) && !this.loading) {
                            this.getMoreProjects()
                        }
                    }
                // }.bind(this), 300)
            },
            getMoreProjects(){
                if(!this.projects?.paginatorInfo?.hasMorePages) return;
                // if(this.projects.loading) return;

                this.currentPage=this.projects.paginatorInfo.currentPage+1;
                this.$apollo.queries.projects.fetchMore({
                    variables: {
                        page: this.currentPage,
                        first: this.pageSize,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        let data = {}
                        data.projects={
                            __typename: fetchMoreResult.projects.__typename,
                            // data: [...previousResult.projects.data, ...fetchMoreResult.projects.data],
                            data: uniqBy([...this.projects.data, ...fetchMoreResult.projects.data], 'id'),
                            paginatorInfo: fetchMoreResult.projects.paginatorInfo
                        }
                        return data
                    },
                })
            }
        },
        watch: {
            loading: function(){
                if(this.loading) return
                this.$nextTick(function(){
                    this.onScroll()
                })
            },
            selectedShift: function(){
                if(this.selectedShift){
                    document.querySelectorAll(".-is-selected").forEach(function(item){
                        item.classList.remove('-is-selected')
                    })
                    document.querySelectorAll(this.selectedShift).forEach(function(item){
                        item.classList.add('-is-selected')
                    })
                }else{
                    document.querySelectorAll(".-is-selected").forEach(function(item){
                        item.classList.remove('-is-selected')
                    })
                }
            },
            daterange: function(){
                clearTimeout(this.projectScrollToTo);
                this.notFetched=false;
                if(this.lastDateRange!=this.daterange.str.from+this.daterange.str.top){
                    this.showProjectsShifts=0
                    this.projectDetailsVisible=0
                    this.showProjectDetails=0
                    this.monthdays=this.setMonthDays();

                    this.showProjects=false

                    setTimeout(function(){
                        if(!this.$apollo.queries.projects.loading) this.showProjects=true
                    }.bind(this), 550)
                }
                this.lastDateRange=this.daterange.str.from+this.daterange.str.top
            },
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-only',
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                update(data){
                    this.myProfileID=data.myProfile.id
                    this.newProjectModel.projectManager=data.myProfile
                    return data
                }
            },
            projects: {
                query: PROJECTSSUMMARY,
                fetchPolicy: 'network-only',
                debounce: 500,
                watchLoading(isLoading){
                    this.loading=isLoading;
                },
                error(error){
                    if (error.message) this.$q.notify({type: 'negative', message: "Oh Oh", caption: error.message});
                },
                variables() {
                    let variables={};
                    if(this.daterange) variables.dateRange=this.daterange.str
                    if(this.daterange) variables.shiftsDateRange=this.daterange.str
                    if(this.projectIDs.length>0) variables.ids=this.projectIDs
                    if (this.moreFilters) variables.moreFilters = this.moreFilters
                    if(this.orderBy){
                        variables.orderBy=this.orderBy
                    }
                    if(this.orderSort){
                        variables.orderSort=this.orderSort
                    }

                    if(variables){
                        return {
                            ...this.queryFilters,
                            ...variables,
                            page: 1,
                            first: this.pageSize,
                            // moreFilters: this.moreFilters
                        }
                    }
                },
                update(data) {
                    this.showProjects = true
                    this.monthdays = this.setMonthDays();
                    this.currentPage=data.projects.paginatorInfo.currentPage;
                    this.earlyFetchedProjects=data.projects;
                    this.$nextTick(function(){
                        if(this.scrollToProject){
                            setTimeout(function(){
                                this.scrollToFunc();
                            }.bind(this), 200)
                        }
                    }.bind(this))

                    return data.projects;
                },
            }
        },
    }
</script>

<style lang="scss" scoped>
    .o-form__input.o-form__input--select, .o-form__input.o-form__input--select:focus, .o-form__input.o-form__input--select:hover {
        color: $color-0-dark;
        background-color: transparent;
        border: none;
        outline: none;
    }
</style>
<style lang="scss">
    @import "@/scss/components/dashboard/MonthView.scss";
</style>
